import { useState, useEffect } from 'react';
import { apiService, getCurrentLocale } from '../services/api';

interface TreatmentZone {
  id: number;
  documentId: string;
  name: string;
  slug?: string;
  description: string;
  detailedDescription?: string;
  suitableFor?: string;
  order: number;
  isActive?: boolean;
  image?: {
    id: number;
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    caption?: string;
    width: number;
    height: number;
    formats?: {
      large?: { url: string; width: number; height: number; size: number; };
      medium?: { url: string; width: number; height: number; size: number; };
      small?: { url: string; width: number; height: number; size: number; };
      thumbnail?: { url: string; width: number; height: number; size: number; };
    };
    hash: string;
    ext: string;
    mime: string;
    size: number;
    previewUrl?: string;
    provider: string;
    provider_metadata?: any;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  };
  ctaButton?: {
    id: number;
    text: string;
    url: string;
    variant: string;
    isExternal: boolean;
  };
  seo?: any;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

interface TreatmentZonesResponse {
  data: TreatmentZone[];
  meta: {
    pagination: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export const useTreatmentZones = () => {
  const [data, setData] = useState<TreatmentZone[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const locale = typeof window !== 'undefined' ? getCurrentLocale() : 'nl';
    const fetchTreatmentZones = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await apiService.getTreatmentZones();
        // The response is already processed by getStrapiData in apiService
        setData(response);
      } catch (err) {
        console.error('Error fetching treatment zones:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch treatment zones');
      } finally {
        setLoading(false);
      }
    };

    fetchTreatmentZones();
  }, [typeof window !== 'undefined' ? getCurrentLocale() : 'nl']);

  return { data, loading, error };
}; 